var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStructuredProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.835 11.2624V3.26239H15.835V6.26239H9.83496V3.26239H2.83496V11.2624H9.83496V8.26239H11.835V18.2624H15.835V21.2624H22.835V13.2624H15.835V16.2624H13.835V8.26239H15.835V11.2624H22.835ZM7.83496 9.26239H4.83496V5.26239H7.83496V9.26239ZM17.835 15.2624H20.835V19.2624H17.835V15.2624ZM17.835 5.26239H20.835V9.26239H17.835V5.26239Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructuredProduct);
export default __webpack_public_path__ + "static/media/structured-product.5c24177668d6257654b73bda665c4eca.svg";
export { ForwardRef as ReactComponent };